import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavDropdown } from 'react-bootstrap';

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();

    const languages = [
        { code: 'en', name: 'English', flag: '🇺🇸' },
        { code: 'fr', name: 'Français', flag: '🇫🇷' },
        { code: 'es', name: 'Español', flag: '🇪🇸' }
    ];

    const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

    const changeLanguage = (langCode) => {
        i18n.changeLanguage(langCode);
    };

    return (
        <NavDropdown
            title={
                <span className="d-flex align-items-center">
          <span className="me-1">{currentLanguage.flag}</span>
          <span>{currentLanguage.name}</span>
        </span>
            }
            id="language-switcher-dropdown"
            className="nav-dropdown"
        >
            {languages.map((language) => (
                <NavDropdown.Item
                    key={language.code}
                    onClick={() => changeLanguage(language.code)}
                    active={i18n.language === language.code}
                >
                    <span className="me-2">{language.flag}</span>
                    {language.name}
                </NavDropdown.Item>
            ))}
        </NavDropdown>
    );
};

export default LanguageSwitcher;